var exports = {
  "k": "container__UPn6G0",
  "U": "elementContainer__3yGXL9",
};

module.exports = exports;
